import React from "react";
import { EmptyWidget } from './EmptyWidget';
import { Salesreport } from './salesreport/Salesreport';
import { Documentation } from './Documentation/Documentation';
import { Tresholds } from './tresholds/Tresholds';
import { DashboardPage } from './dashboardPage/DashboardPage';
import { Integrations } from './integrations/Integrations';
import { SalesDetalization } from './salesDetalization/SalesDetalization';
import { UserSettings } from './UserSettings/UserSettings';
import { AdminSettings } from './AdminSettings/AdminSettings';
import { AdminVatRates } from './AdminVatRates/AdminVatRates';
import { HistoricalVatRates } from '../Pages/HistoricalVatRates/HistoricalVatRates';
import { Orders } from './Orders/Orders';
import { FileImport } from '../../components/Pages/FileImport/FileImport';
import { UserFileImport } from '../../components/Pages/UserFileImport/UserFileImport';
import { AdminReturns } from '../../components/Pages/AdminReturns/AdminReturns';
import { UserReturns } from '../../components/Pages/UserReturns/UserReturns';
import { ReturnsCalendar } from '../../components/Pages/ReturnsCalendar/ReturnsCalendar';
import { AdminRates } from '../../components/Pages/AdminRates/AdminRates';

import { Profile } from './UserMenu/Profile';
import { VatRegistrations } from './UserMenu/VatRegistrations';

export const DashboardContent = (props) => {
  const getContentForDashboard = () => {
    switch (props.match.params.sectionType) {
      case "integrations": {
        return <Integrations />;
      }
      case "documentation": {
        return <Documentation />;
      }
      case "apilog": {
        return <EmptyWidget
          text="No data imported yet"
          ctaText="Let's start with your first integration?"
          buttonText='Go to integrations'
          buttinLink='/user/provider'
        />;
      }
      case "dashboard": {
        return <DashboardPage
          globalCurrency={props.globalCurrency}
          changeGlobalCurrency={props.changeGlobalCurrency}
          globalDays={props.globalDays}
          changeGlobalDays={props.changeGlobalDays}
        />;
      }
      case "tresholds": {
        return <Tresholds
          globalCurrency={props.globalCurrency}
        />;
      }
      case "salesreport": {
        return <Salesreport 
          globalCurrency={props.globalCurrency}
          changeGlobalCurrency={props.changeGlobalCurrency}
          globalDays={props.globalDays}
          changeGlobalDays={props.changeGlobalDays}
        />
      }
      case "salesdetalization": {
        return <SalesDetalization 
          globalCurrency={props.globalCurrency}
        />;
      }

      case "profile": {
        return <Profile />;
      }

      case "vatreg": {
        return <VatRegistrations />;
      }

      case "settings": {
        return <UserSettings />;
      }

      case "adminsettings": {
        return <AdminSettings />;
      }

      case "adminvatrates": {
        return <AdminVatRates />;
      }

      case "historicalvatrates": {
        return <HistoricalVatRates />;
      }

      case "admincurrencyrates": {
        return <AdminRates />;
      }

      case "adminfileimport": {
        return <FileImport />;
      }

      case "userfileimport": {
        return <UserFileImport />;
      }

      case "returnsadmintable": {
        return <AdminReturns />;
      }

      case "returnsusertable": {
        return <UserReturns />;
      }

      case "orders": {
        return <Orders />;
      }

      case "returnsusercalendar": {
        return <ReturnsCalendar />;
      }

      default: {
        return <h2> Page is still under construction.</h2>;
      }
    }
  };

  return <div className="Dashboard__content">{getContentForDashboard()}</div>;
};
